<div class="container">
  <div class="title">{{ invoiceRecord.invoiceNo }}</div>
  <div class="action_buttons">
    <div class="action_button" (click)="onActionClick('view')">
      <app-svg-icon [path]="'assets/icons/view_icon.svg'"></app-svg-icon>
      View
    </div>
    <div class="action_button">
      <app-svg-icon [path]="'assets/icons/send_icon.svg'"></app-svg-icon>
      Send
    </div>
    <div class="action_button" (click)="onActionClick('pdf-print')">
      <app-svg-icon [path]="'assets/icons/document_icon.svg'"></app-svg-icon>
      PDF/Print
    </div>
    <div class="action_button" (click)="onActionClick('record-payment')">
      <app-svg-icon [path]="'assets/icons/record_payment_icon.svg'"></app-svg-icon>
      Record Payment
    </div>
    <div class="action_button" (click)="onActionClick('credit-note')">
      <app-svg-icon [path]="'assets/icons/credit_note_icon.svg'"></app-svg-icon>
      Create Credit Note
    </div>
    <div class="action_button" (click)="onActionClick('cancel-invoice')">
      <app-svg-icon style="background-color: #D92D20" [path]="'assets/icons/delete_icon.svg'"></app-svg-icon>
      Cancel
    </div>
  </div>
  <div class="accordion_container">
    <mat-expansion-panel #expansionPanel [expanded]="false" (click)="$event.stopPropagation()" [hideToggle]="true">
      <mat-expansion-panel-header (click)="$event.stopPropagation()">
        <mat-panel-title (click)="$event.stopPropagation()">
          <app-horizontal-tabs class="clickable"
                               [tabs]="tabs"
                               [selectedTab]="selectedTab"
                               (tabSelected)="changeSelectedTabAndToggleAccordion($event)"
          ></app-horizontal-tabs>
        </mat-panel-title>
        <div class="icon_cover" (click)="$event.stopPropagation()">
          <mat-icon class="clickable" (click)="toggleAccordion()">
            <app-svg-icon
              [path]="expansionPanel.expanded ? 'assets/icons/chevron_up.svg' : 'assets/icons/chevron_down.svg'"></app-svg-icon>
          </mat-icon>
        </div>
      </mat-expansion-panel-header>
      <ng-container *ngIf="expansionPanel.expanded">
        @if (selectedTab === TABS.PAYMENT) {
          @if (isLoading) {
            <app-skeleton-loader count="5"></app-skeleton-loader>
          } @else {
            @if (paymentReceivedData.length === 0) {
              <app-no-data [msg]="'No Payment Records Found!'"></app-no-data>
            } @else {
              <div class="table_container">
                <table>
                  <thead>
                  <tr>
                    <th>Date</th>
                    <th>Receip tNo</th>
                    <th style="width: 350px">Paying Party</th>
                    <th>Total Amount</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                    @for (paymentReceived of paymentReceivedData; track paymentReceived.id) {
                      <tr>
                        <td>{{ DateUtils.formatDate(paymentReceived.paymentDate, "dd/MM/yyyy") }}</td>
                        <td>{{ paymentReceived.receiptNo }}</td>
                        <td>{{ paymentReceived?.payingParty?.name }}</td>
                        <td>{{ paymentReceived?.totalAmount }}</td>
                        <td class="receipt_download_btn">Receipt
                          <app-svg-icon style="height: 16px;width: 16px;background: #1D7EDA;display: flex"
                                        [path]="'assets/icons/download_icon.svg'"></app-svg-icon>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          }
        } @else if (selectedTab === TABS.CREDIT_NOTE) {
          @if (isLoading) {
            <app-skeleton-loader count="5"></app-skeleton-loader>
          } @else {
            @if (creditNoteData.length === 0) {
              <app-no-data [msg]="'No Credit Notes Found!'"></app-no-data>
            } @else {
              <div class="table_container">
                <table>
                  <thead>
                  <tr>
                    <th>Credit Note Number</th>
                    <th style="width: 350px">Charge</th>
                    <th>Amount</th>
                    <th>Credit Type</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                    @for (creditNote of creditNoteData; track creditNote.id) {
                      <tr>
                        <td>{{ creditNote.sequenceNo }}</td>
                        <td>{{ creditNote?.charge?.printName }}</td>
                        <td>{{ creditNote?.amount }}</td>
                        <td>{{ creditNote?.creditType }}</td>
                        <td></td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          }
        }
      </ng-container>
    </mat-expansion-panel>
  </div>


  <div class="invoice-content">
    @if (invoiceRecord.status === 'PENDING') {
      <app-irn-gen-error
        [invoice]="invoiceRecord"
      ></app-irn-gen-error>
    } @else {
      @if(isLoading && !pdfSrc){
        <app-spinner-loader style="height: 60vh"></app-spinner-loader>
      } @else {
        <pdf-viewer
          *ngIf="pdfSrc"
          [src]="pdfSrc"
          [show-borders]="true"
          style="width: 100%; height: 100vh;"
        >
        </pdf-viewer>
      }

    }
  </div>

</div>

